/**
 * Optional Google Analytics 4 (gtag.js). Enable with VITE_GA_MEASUREMENT_ID (e.g. G-XXXXXXXX).
 * Load only after analytics consent; events are no-ops without consent or ID.
 */

let ga4LoadStarted = false;

function measurementId(): string | undefined {
  const id = import.meta.env.VITE_GA_MEASUREMENT_ID;
  return typeof id === 'string' && id.trim().startsWith('G-') ? id.trim() : undefined;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/** Injects gtag.js once when a measurement ID is configured. Safe to call multiple times. */
export function ensureGa4Loaded(): void {
  if (typeof window === 'undefined') return;
  const id = measurementId();
  if (!id || ga4LoadStarted) return;
  ga4LoadStarted = true;

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', id, { anonymize_ip: true });

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
}

export function sendGa4Event(eventName: string, params: Record<string, string | number>): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}
